import { injectable } from "inversify";
import IRepository from 'data/IRepository';
import { inversifyContainer } from 'infrastructure/ioc/ioc.container';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import { getQueryParams } from 'features/shared/helpers/queryParams';
import { Contract_EnergyType, Enums_DistributionRateType } from 'data/endpoints';
import { getRouteParams } from 'features/shared/helpers/routeParams';
import IDistRateCircuitBreakerFormService from "./IDistRateCircuitBreakerFormService";
import ElectricityLowVoltageDTO from "features/contracts/dtos/ElectricityLowVoltageDTO";
import { ContractType } from "features/contracts/enums/contractType";
import DistributionRateTypeEnumDTO from "features/shared/enums/dynamic/DistributionRateTypeEnumDTO";
import { ValueActionType } from "features/shared/forms/hooks/useForm";

@injectable()
export default class DistRateCircuitBreakerFormService implements IDistRateCircuitBreakerFormService {
  private readonly _lowVoltagesRepository: IRepository<ElectricityLowVoltageDTO>;
  private readonly _enumRepository: IRepository<DistributionRateTypeEnumDTO>;
    
  constructor() {
    this._lowVoltagesRepository = inversifyContainer.get<IRepository<ElectricityLowVoltageDTO>>(IocTypes.Repository);
    this._enumRepository = inversifyContainer.get<IRepository<DistributionRateTypeEnumDTO>>(IocTypes.Repository);
  }

  fetchElectricityLowVoltage(contractId: string): Promise<ElectricityLowVoltageDTO> {
    let routeParams = getRouteParams("contractId", contractId);
    routeParams.set("energyType", ContractType.ElectricityLowVoltage);

    return this._lowVoltagesRepository.getOne({
      url: Contract_EnergyType,
      routeParams: routeParams
    });
  }

  fetchDistributionRates(contractId: string): Promise<DistributionRateTypeEnumDTO[]> {
    return this._enumRepository.get({
      url: Enums_DistributionRateType,
      params: getQueryParams("contractId", contractId)
    });
  }

  setFetchedContractEnergy(contractEnergy: ElectricityLowVoltageDTO, setFormValue: (key: string, value: any, action: ValueActionType) => void): void {
    // original values
    setFormValue("DESC_TMZMSMLEEFAZEPUVODNI", String(contractEnergy.phase), "add");
    setFormValue("DESC_TMZMSMLEEJISTICPUVOD", String(contractEnergy.circuitBreaker), "add");
    setFormValue("DESC_TMZMSMLEESAZBAPUV", contractEnergy.distributionRate, "add");
    // new values
    setFormValue("DESC_TMZMSMLEEFAZE", String(contractEnergy.phase), "add");
    setFormValue("DESC_TMZMSMLEEJISTIC", String(contractEnergy.circuitBreaker), "add");
    setFormValue("DESC_TMZMSMLEESAZBA", contractEnergy.distributionRate, "add");
  }
}